import React from 'react';
import '../styles/Politicas.css';

const Politicas: React.FC = () => {
  return (
    <section className="pagina-contenedor">
      <h2 className="titulo-seccion">Políticas y Términos</h2>

      <article className="politica-bloque">
        <h3>🛒 Política de Compras</h3>
        <p>
          Todos los productos de Prodnook se venden con boleta o factura. 
          Los precios incluyen IVA y pueden variar sin previo aviso. 
          Las ofertas publicadas en nuestro sitio web son válidas hasta agotar stock.
        </p>
      </article>

      <article className="politica-bloque">
        <h3>🚚 Envíos</h3>
        <p>
          Realizamos envíos a todo Chile a través de empresas de transporte certificadas. 
          Una vez confirmado el pago, tu pedido será procesado y despachado en un plazo de 24 a 48 horas hábiles.
        </p>
      </article>

      <article className="politica-bloque">
        <h3>🔁 Cambios y Devoluciones</h3>
        <p>
          Puedes solicitar cambios o devoluciones dentro de los 10 días posteriores a la entrega, 
          siempre que el producto esté en su empaque original y sin uso.
        </p>
      </article>

      <article className="politica-bloque">
        <h3>🔒 Privacidad</h3>
        <p>
          En Prodnook valoramos tu privacidad. La información personal que nos entregas 
          se utiliza exclusivamente para procesar tus pedidos y mejorar tu experiencia.
        </p>
      </article>
    </section>
  );
};

export default Politicas;
